// src/components/helpers.js
/* -------- colour helpers -------- */
export const COLOR_NAMES = {
	Red:{r:239,g:68,b:68},  Orange:{r:249,g:115,b:22}, Amber:{r:245,g:158,b:11},
	Lime:{r:132,g:204,b:22},Green:{r:34,g:197,b:94},   Cyan:{r:6 ,g:182,b:212},
	Blue:{r:59,g:130,b:246},Indigo:{r:99,g:102,b:241}, Pink:{r:236,g:72 ,b:153},
	Black:{r:0 ,g:0 ,b:0},  White:{r:255,g:255,b:255}, 'Custom Color':{r:0,g:0 ,b:0}
};

export const hexToRgb = (hex)=>{
	let r=0,g=0,b=0;
	if(hex.length===4){r=parseInt(hex[1]+hex[1],16);g=parseInt(hex[2]+hex[2],16);b=parseInt(hex[3]+hex[3],16);}
	if(hex.length===7){r=parseInt(hex[1]+hex[2],16);g=parseInt(hex[3]+hex[4],16);b=parseInt(hex[5]+hex[6],16);}
	return {r,g,b};
};

export const getNearestColorName = (hex)=>{
	const sel = hexToRgb(hex); let min=Infinity,nearest='Custom Color';
	Object.entries(COLOR_NAMES).forEach(([name,rgb])=>{
		const d=Math.sqrt((rgb.r-sel.r)**2+(rgb.g-sel.g)**2+(rgb.b-sel.b)**2);
		if(d<min){min=d;nearest=name;}
	});
	return nearest;
};

/* -------- size map -------- */
export const SIZE_CATEGORIES = {
	Clothing:{ Men:['XS','S','M','L','XL','XXL'],
		Women:['XS','S','M','L','XL','XXL'],
		Unisex:['XS','S','M','L','XL','XXL'] },
	Shoes:{ 'US Men':['7','8','9','10','11','12'],
		'US Women':['5','6','7','8','9','10'] },
	Accessories:{ Hats:['S','M','L','XL','One size'] }
};
